import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Card, Icon, Title, TopSection } from "./Card.Style";
import gist_v from "../../../../assets/gi/gist_v.svg";

const dont_forget = "/List.svg";

export default function DontForget({ keyPrefix = "" }) {
  const { t } = useTranslation();
  return (
    <Card>
      <TopSection>
        <Title>
          {t(`${keyPrefix}Dont-Forget-Title`)}
        </Title>
        <Icon src={dont_forget} alt="dontForget" />
      </TopSection>

      <ListContainer>
        {dontForgetItems.map((dontForgetItem) => (
          <ListItem key={dontForgetItem} $bold={dontForgetItem === "companion"}>
            {t(`${keyPrefix}Dont-Forget-${dontForgetItem}`)}
          </ListItem>
        ))}
      </ListContainer>
    </Card>
  );
}

const dontForgetItems = [
  "identification",
  "medicalReferral",
  "bloodCounting",
  "companion",
];

const ListContainer = styled.ul`
  padding-inline-start: 1.5rem;
  margin: 0;
`;

const ListItem = styled.li`
  list-style-image: url("${gist_v}");
  font-size: 1.1875rem;
  font-weight: ${({ $bold }) => ($bold ? "700" : "400")};
`;
